var hasProp = window.hasProp;
var extend = window.extend;
var extend = function (child, parent) {
    for (var key in parent) {
      if (hasProp.call(parent, key)) child[key] = parent[key];
    }
    function ctor() {
      this.constructor = child;
    }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
    child.__super__ = parent.prototype;
    return child;
  },
  hasProp = {}.hasOwnProperty;
Aedu.Notifications.NotificationCollection = function (superClass) {
  extend(NotificationCollection, superClass);
  function NotificationCollection() {
    return NotificationCollection.__super__.constructor.apply(this, arguments);
  }
  NotificationCollection.prototype.model = Aedu.Notifications.Notification;
  return NotificationCollection;
}(Backbone.Collection);
window.extend = extend;
window.hasProp = hasProp;